import { Container, Row, Col, Button, Form, Alert } from 'react-bootstrap';
import '../../App.css';
import '../../css/bootstrap.scss';
import signup_banner from "../../images/fx-rates.png";
import Header from '../Includes/Header';
import Footer from '../Includes/Footer';
import { useNavigate } from 'react-router-dom';
import BackButton from '../Includes/BackButton';
import { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import config from '../../config';
import { useLocation } from "react-router-dom";
import { Field, reduxForm, InjectedFormProps } from 'redux-form';
import { connect } from 'react-redux';
import { setEmail, setResetPasswordWizardPageNumber } from '../ResetPasswordReducer';
import { RootState } from '../store';
import { useDispatch, useSelector } from 'react-redux';
import renderField from '../renderField';
import { ToastBox, notifyError, notifySuccess } from 'MyComponents/Toaster';
import SuccessOTPModal from '../Camera/SuccessOTPModal';
import Spinner from 'react-bootstrap/Spinner';
import { useTranslation } from 'react-i18next';

interface FormData {
    password: string;
    userId: string;
}

interface Props { };

const NewPassword: React.FC<Props & InjectedFormProps<{}, Props, FormData>> = (props: any) => {
    const { t } = useTranslation();
    const { handleSubmit } = props;
    const dispatch = useDispatch();
    const email = useSelector((state: RootState) => state.resetPassword.email);
    const page = useSelector((state: RootState) => state.resetPassword.wizardPageNumber);
    const [passwordValidationError, setPasswordValidationError] = useState(false);
    const [validations, setValidations] = useState({
        minLength: false,
        hasNumber: false,
        hasUppercase: false,
        hasSpecialCharacter: false,
        hasLowercase: false
    });
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [passwordValidation, setPasswordValidation] = useState(false);

    const startLoading = () => {
        setLoading(true);
    };

    const [eyeStatus, setEyeStatus] = useState(true);

    const [showModal1, setShowModal1] = useState(false);

    const handleShowModal1 = () => {
        setShowModal1(true);
    };
    const handleCloseModal1 = async () => {
        setShowModal1(false);
    };

    const resetPassword_baseURL = config.NODE_API_BASE_URL_V2 + '/wso2/resetPassword';

    const [showPassword, setShowPassword] = useState(false);

    const handleTogglePassword = () => {
        setShowPassword(!showPassword);
    };

    const validatePasswordField = (value: any) => {
        if (!value) {
            return t('common.password_required');
        }
        return undefined;
    };

    const submitForm = async (formValues: FormData) => {
        setIsSubmitted(true);

        if (passwordValidationError) {
            setPasswordValidation(true);
            return;
        }
        startLoading();

        const Response = await changePassword(email, formValues.password);

        if (Response.status) {
            setIsSubmitted(false);
            handleShowModal1();
        }
    };

    const handleChange = (e: any) => {
        const newPassword = e.target.value;
        setPasswordValidation(false);
        setValidations({
            minLength: newPassword.length >= 8,
            hasNumber: /\d/.test(newPassword),
            hasUppercase: /[A-Z]/.test(newPassword),
            hasSpecialCharacter: /[!@#$%^&*(),.?":{}|<>]/.test(newPassword),
            hasLowercase: /[a-z]/.test(newPassword),
        });
    };

    useEffect(() => {
        const hasValidationError = Object.values(validations).some((valid) => !valid);
        setPasswordValidationError(hasValidationError);
    }, [validations]);

    const changePassword = async (email: string, password: string) => {
        const resetPasswordResponse = await axios.post(resetPassword_baseURL, {
            email: email,
            password: password
        });

        return resetPasswordResponse.data;
    };

    return (
        <>
            <Header />

            <SuccessOTPModal
                show={showModal1}
                handleClose={handleCloseModal1}
                title={t('camera.reset_completed')}
            />

            <ToastBox />
            <Container fluid className='min-vh-custom'>
                <Row>
                    <Col md={1}></Col>

                    <Col md={5} >
                        <div className='mt-5 px-4'>
                            <br />
                            <BackButton />
                            <br />
                            <br />

                            <p className='text-primary fw-medium fs-5 mt-5'>{t('login.new_password_title')}</p>
                            <Form noValidate={true} onSubmit={handleSubmit(submitForm)}>
                                <label htmlFor="password" className="form-label">{t('common.password')}</label>
                                <div className='input-group password_field'>
                                    <Field
                                        type={showPassword ? 'text' : 'password'}
                                        component={renderField}
                                        className="form-control rounded-5 py-2 mt-2"
                                        placeholder={t('login.type_password')}
                                        id="password"
                                        name="password"
                                        validate={validatePasswordField}
                                        required
                                        onChange={handleChange}
                                    />

                                    {passwordValidation && (
                                        <p className='text-danger text-start small fw-bold mt-2'>
                                            {t('login.invalid_password')}
                                        </p>
                                    )}
                                    <span
                                        className="bg-transparent border-0 icon p-eye"
                                        onClick={handleTogglePassword}
                                    >
                                        <i className={showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'}></i>
                                    </span>
                                </div>
                                <div className='mt-3 col-md-11 bg-sky  rounded-4'>
                                    <Form.Text className="text-muted">
                                        <div className='px-3 py-3 pb-3'>
                                            <span className="text-secondary">
                                                <i className={`fa-solid ${validations.minLength ? 'fa-circle-check text-success' : 'fa-circle-xmark text-danger'}`}></i>
                                                &nbsp;&nbsp;&nbsp;&nbsp;{t('common.pass_min_length')}
                                            </span>
                                            <br />
                                            <span className="text-secondary">
                                                <i className={`fa-solid ${validations.hasNumber ? 'fa-circle-check text-success' : 'fa-circle-xmark text-danger'}`}></i>
                                                &nbsp;&nbsp;&nbsp;&nbsp;{t('common.pass_has_number')}
                                            </span>
                                            <br />
                                            <span className="text-secondary">
                                                <i className={`fa-solid ${validations.hasUppercase ? 'fa-circle-check text-success' : 'fa-circle-xmark text-danger'}`}></i>
                                                &nbsp;&nbsp;&nbsp;&nbsp;{t('common.pass_has_upper')}
                                            </span>
                                            <br />
                                            <span className="text-secondary">
                                                <i className={`fa-solid ${validations.hasLowercase ? 'fa-circle-check text-success' : 'fa-circle-xmark text-danger'}`}></i>
                                                &nbsp;&nbsp;&nbsp;&nbsp;{t('common.pass_has_lower')}
                                            </span>
                                            <br />
                                            <span className="text-secondary">
                                                <i className={`fa-solid ${validations.hasSpecialCharacter ? 'fa-circle-check text-success' : 'fa-circle-xmark text-danger'}`}></i>
                                                &nbsp;&nbsp;&nbsp;&nbsp;{t('common.pass_has_special')}
                                            </span>
                                        </div>
                                    </Form.Text>
                                </div>

                                <div className='col-md-6 mt-4'>
                                    <Button variant="primary" type="submit" className="btn btn-primary rounded-5 mt-3" disabled={(loading && isSubmitted)}>
                                        {loading && isSubmitted && (
                                            <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                                className='mx-2'
                                            />
                                        )}
                                        <span>{t('login.reset_title')}</span>
                                    </Button>{' '}
                                </div>
                            </Form>
                        </div>
                    </Col>
                    <Col md={6} className=' text-center bg-sky'>
                        <br /><br /><br /><br /><br /><br />
                        <img src={signup_banner} className="img-fluid" style={{ maxWidth: 500, width: "100%" }} alt="banner" />
                        <br /><br /><br />
                        <h2>{t('common.all_in_one')}</h2>
                        <p className='text-secondary mb-3'>{t('common.all_in_one_desc')}</p>
                    </Col>
                </Row>
            </Container>
            <Footer full={false} />
        </>
    );
};

const mapStateToProps = (state: RootState) => ({
    initialValues: {
        password: '',
    },
});

const form = reduxForm<{}, Props, FormData>({
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    form: 'wizard',
    enableReinitialize: true,
})(NewPassword);

export default connect(mapStateToProps)(form);
